import React, { useCallback, useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDropzone } from 'react-dropzone';
import ProfileUploader from './profile-uploader';
import BCStep2 from '../images/BC-Step-2.png';
import ProfileCoverUploader from './ProfileCover-uploader';
import SubCovers from './SubCovers';
import { connect, useDispatch } from 'react-redux';
import { setAlert } from '../../redux/actions';
import { NUT_THEME_USERS, ROLES } from '../utils/constants';
import ProfileCoverLandscape from './ProfileCoverLandscape';
// const userInformation = JSON.parse(localStorage.getItem('user'));

const ProfileCoverPhotos = ({ user, showHeader, getUserInformation, userInformation }) => {

    const dispatch = useDispatch();

    const [showPanelHeader, setShowPanelHeader] = useState(true);
    const [isCoverLoading, setIsCoverLoading] = useState(false);
    const [cover, setCover] = useState('');
    const [coverObj, setCoverObj] = useState('');
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [profileBkg, setProfileBkg] = useState(false);

    const onDropRejected = useCallback(() => {
        setError('Only .jpg, .jpeg, .png files are accepted');
    }, []);

    const onDropAccepted = useCallback((acceptedFiles) => {
        setCover(acceptedFiles[0]);
        setCoverObj(URL.createObjectURL(acceptedFiles[0]));
        upload(acceptedFiles[0]);
    }, []);

    useEffect(() => {
        setShowError(true);
    }, [showError]);

    useEffect(() => {
        let isMounted = true;
        if (typeof showHeader === 'undefined') {
            setShowPanelHeader(true);
        } else {
            setShowPanelHeader(showHeader);
        }

        return () => { isMounted = false; };
    }, []);

    useEffect(() => {
        let isMounted = true;
        if (userInformation && userInformation.creator) {
            setProfileBkg(userInformation.creator.profile_bkg);
        }
        return () => { isMounted = false; };
    }, [userInformation]);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
    } = useDropzone({
        onDropRejected,
        onDropAccepted,
        accept: 'image/jpeg, image/png',
        maxFiles: 1,
        multiple: false,
    });

    const upload = async (payload) => {
        setIsCoverLoading(true);
        const formData = new FormData();
        formData.append('cover_pic', payload, payload.name);
        await axios.post(
            `/api/users/${userInformation.id}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        )
            .then((response) => {
                getUserInformation();
                setIsCoverLoading(false);
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Photo successfully updated'
                }));
            })
            .catch((error) => {
                console.log({ error });
                setIsCoverLoading(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to update photo'
                }));
            });
    };

    const handleCoverType = (e) => {
        if (e.target.value === 'cover') {
            setProfileBkg(false);
            updateType(false);
        } else {
            setProfileBkg(true);
            updateType(true);
        }
    };

    const updateType = (isProfileBkg = null) => {
        axios.patch(`/api/creators/${userInformation.creator.id}`, {
            profile_bkg: isProfileBkg
        })
            .then(response => {
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: `${isProfileBkg ? 'Background' : 'Cover'} mode enabled`
                }));
            })
            .catch(error => {
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: `Failed to update ${isProfileBkg ? 'background' : 'cover'} mode`
                }));
            });
    };

    return (
        <div className="panel panel-default">
            {
                showPanelHeader && (
                    <div className="panel-heading refpayout">
                        <span className="BC-head-ico">
                            <LazyLoadImage src={BCStep2} />
                        </span>
                        <span>
                            Step 3 - Profile & Cover Photos
                        </span>
                    </div>
                )
            }
            <div className="panel-body">
                <form className="cmxform" id="subscription_payment_form" name="subscription_payment_form" method="post" action="" encType="multipart/form-data" noValidate="novalidate">
                    <div className="become-creator-profile-cover">
                        <div className="profile-cover-box mb-3">
                            <div className="profile-box text-center">
                                <h5><b>Profile</b></h5>
                                {user && <ProfileUploader getUserInformation={getUserInformation} />}
                            </div>
                            <div
                                className="cover-box text-center"
                                style={{
                                    fontSize: '16px',
                                    fontWeight: '700'
                                }}
                            >
                                {user.role == ROLES.SU && <h5><b>Cover Photo</b></h5>}

                                {
                                    user.role == ROLES.PU && NUT_THEME_USERS.includes(user.id) && <React.Fragment><div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="cover"
                                            id="coverType"
                                            value="cover"
                                            checked={!profileBkg}
                                            onChange={handleCoverType}
                                        />
                                        <label className="form-check-label" htmlFor="coverType">Cover</label>
                                    </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="cover"
                                                id="coverType"
                                                value="background"
                                                checked={profileBkg}
                                                onChange={handleCoverType}
                                            />
                                            <label className="form-check-label" htmlFor="coverType">Background</label>
                                        </div>
                                    </React.Fragment>
                                }

                                {user && <ProfileCoverUploader
                                    user={user}
                                    getUserInformation={getUserInformation}
                                    profileBkg={profileBkg}
                                />}

                                {
                                    profileBkg && user.role == ROLES.PU && NUT_THEME_USERS.includes(user.id) && <React.Fragment>
                                        <ProfileCoverLandscape
                                            user={user}
                                            getUserInformation={getUserInformation}
                                            profileBkg={profileBkg}
                                        />
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                        <div className="my-3 text-danger">
                            {error}
                        </div>
                        <div className='my-2'>
                            <SubCovers profileBkg={profileBkg} />
                        </div>
                        <p>*Profile images must not contain nudity or explicit material.</p>
                    </div>
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        userInformation: state.user.user
    };
};

export default connect(mapStateToProps)(ProfileCoverPhotos);
